import React from 'react';
import { Field } from 'redux-form';
import { useTranslation } from 'react-i18next';

import HelpIcon from '@material-ui/icons/Help';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';

import { DEFAULT_LANGUAGE } from 'pages/create-activity/constants';
import { TRANSLATIONS } from 'translations/index';

import {
  CurrencyInputWrapper,
  Input,
  MultipleSelectField,
  PopoverWrapper,
  TextareaInput,
  DndUploadImage
} from 'components';

import { useStyles } from './styles';

const AddOnsFields = ({
  field,
  index,
  meta: { error, submitFailed },
  ...otherProps
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;

  const additionalLanguage =
    selectedLanguage !== DEFAULT_LANGUAGE ? `.${selectedLanguage}` : '';

  return (
    <div className={classes.wrapper}>
      <MultipleSelectField
        availableItems={[]}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
        className={classes.multiSelectWrapper}
      />
      <Typography variant="body1" className={classes.title}>
        {t(TRANSLATIONS[selectedLanguage].titleAndDescription)}
      </Typography>
      <Field
        name={`${field}${additionalLanguage}.title`}
        component={Input}
        className={classes.inputIndent}
        placeholder={`${TRANSLATIONS[selectedLanguage].title}`}
        label={`${TRANSLATIONS[selectedLanguage].title} *`}
        maxLength="255"
      />
      <Field
        name={`${field}${additionalLanguage}.description`}
        className={classes.inputIndent}
        placeholder={`${TRANSLATIONS[selectedLanguage].description}`}
        label={`${TRANSLATIONS[selectedLanguage].description}`}
        maxLength="1000"
        component={TextareaInput}
      />
      {!additionalLanguage && (
        <>
          <div className={classes.imgContainer}>
            <Field
              name={`${field}.coverPhoto`}
              label="Cover photo"
              isDelete={true}
              component={DndUploadImage}
            />
          </div>
          <div>
            <Typography variant="body1" className={classes.title}>
              {t('Prices')}
            </Typography>
            <div className={classes.row}>
              <Field
                name={`${field}.NOK`}
                label="NOK"
                isHiddenErrorMsg={true}
                className={classes.currencyField}
                component={CurrencyInputWrapper}
              />
              <Field
                name={`${field}.EUR`}
                label="EUR"
                isHiddenErrorMsg={true}
                className={classes.currencyField}
                component={CurrencyInputWrapper}
              />
              <Field
                name={`${field}.USD`}
                label="USD"
                isHiddenErrorMsg={true}
                className={classes.currencyField}
                component={CurrencyInputWrapper}
              />
              <PopoverWrapper text="Value for at least one currency for each category should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>
            {submitFailed &&
              error &&
              error['_error'] &&
              error['_error'][index] && (
                <FormHelperText error>
                  {t(error['_error'][index])}
                </FormHelperText>
              )}
          </div>
        </>
      )}
    </div>
  );
};

export default AddOnsFields;
